import React from 'react'
import { NOT_AVAILABLE } from 'utils/constants'
import styles from './NoData.scss'

const NoData: React.FC = () => <span className={styles.wrapper}>{NOT_AVAILABLE}</span>

export default NoData

